import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauthorize-page',
  imports: [CommonModule],
  standalone: true,
  template: `
       <div style="display: flex; align-items: center; justify-content: center; height: 85vh;">
          <p>{{errorMsg}}</p>
       </div>
  `
})
export class UnauthorizePageComponent implements OnInit {
  errorMsg!: String;

  constructor(private router: Router) {
    const nav = this.router.getCurrentNavigation();
    if (nav?.extras.state) {
      this.errorMsg = nav.extras.state['errorMsg']
    }
  }

  ngOnInit(): void {
  }
}
